// extracted by mini-css-extract-plugin
export default {"Tooltip":"EvergreenRecycle_Tooltip__A0AO0","TooltipExpireAfter":"EvergreenRecycle_TooltipExpireAfter__qx+ie","ExpiryTitle":"EvergreenRecycle_ExpiryTitle__cWtSo"};